module.exports = __webpack_public_path__ + "img/c03_unitcarpentomchampion_Normal_ua.07ba2efc.webp";